import { render, staticRenderFns } from "./SalaryReceiptDetail.vue?vue&type=template&id=cbad84d6&scoped=true&"
import script from "./SalaryReceiptDetail.vue?vue&type=script&lang=js&"
export * from "./SalaryReceiptDetail.vue?vue&type=script&lang=js&"
import style0 from "./SalaryReceiptDetail.vue?vue&type=style&index=0&id=cbad84d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbad84d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbad84d6')) {
      api.createRecord('cbad84d6', component.options)
    } else {
      api.reload('cbad84d6', component.options)
    }
    module.hot.accept("./SalaryReceiptDetail.vue?vue&type=template&id=cbad84d6&scoped=true&", function () {
      api.rerender('cbad84d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Payroll/SalaryReceiptDetail.vue"
export default component.exports